import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface RouteTitle {
  [key: string]: string;
}

const routeTitles: RouteTitle = {
  "/": "NIMBO - Login",
  "/dashboard": "NIMBO - Dashboard",
  "/user-management": "NIMBO - User Management",
  "/user/profile": "NIMBO - User Profile",
  "/staff-management": "NIMBO - Staff Management",
  "/hub-management": "NIMBO - Hub Management",
  "/vehicle-management": "NIMBO - Vehicle Management",
  "/rental-management": "NIMBO - Rental Management",
  "/payment-management": "NIMBO - Payment Management",
  "/refund-management": "NIMBO - Refund Management",
  "/plan-management": "NIMBO - Plan Management",
  "/booking-management": "NIMBO - Booking Management",
  "/ride-management": "NIMBO - Ride Management",
  "/support": "NIMBO - Support System",
  "/settings": "NIMBO - Setting",
  "/marketing/promo-codes": "NIMBO - Promo Codes",
  "/marketing/promo-codes/create": "NIMBO - Create Promocode",
  "/marketing/referral-settings": "NIMBO - Referral Settings",
};

// Handle dynamic routes
const getDynamicTitle = (pathname: string): string => {
  if (pathname.startsWith("/staff-management/edit-staff/")) {
    return "NIMBO - Staff Management / Edit Staff";
  }
  if (pathname.startsWith("/staff-management/create-staff")) {
    return "NIMBO - Staff Management / Create Staff";
  }
  if (pathname.startsWith("/ride-management/ride-details/")) {
    return "NIMBO - Ride Management / Ride Details";
  }
  return routeTitles[pathname] || "NIMBO";
};

const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Update document title based on current route
    const pathname = location.pathname;
    const title = getDynamicTitle(pathname);
    document.title = title;

    // Update favicon to ensure it's always the NIMBO logo
    const updateFavicon = () => {
      // Remove existing favicon links
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
      existingFavicons.forEach((link) => link.remove());

      // Add the NIMBO favicon with cache busting
      const favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.type = "image/svg+xml";
      favicon.href = `/logo.svg?t=${Date.now()}`;
      document.head.appendChild(favicon);

      // Add alternate favicon for older browsers
      const alternateFavicon = document.createElement("link");
      alternateFavicon.rel = "alternate icon";
      alternateFavicon.href = `/favicon.ico?t=${Date.now()}`;
      document.head.appendChild(alternateFavicon);

      // Force browser to reload favicon
      const link = document.querySelector(
        'link[rel="icon"]',
      ) as HTMLLinkElement;
      if (link) {
        link.href = link.href;
      }
    };

    updateFavicon();
  }, [location.pathname]);
};

export default useDocumentTitle;
